import { Component, inject, Input } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Task } from '../../../models/task.model';
import { Priority } from '../../../models/priority.model';
import { TaskService } from '../../../services/task.service';

@Component({
    selector: 'app-task-form',
    templateUrl: './task-form.component.html',
    styleUrls: ['./task-form.component.scss'],
    standalone: false
})
export class TaskFormComponent {
    @Input() public task: Task | null = null;

    protected readonly priority = Priority;
    private toastController: ToastController = inject(ToastController);
    private taskService: TaskService = inject(TaskService);
    private translate: TranslateService = inject(TranslateService);

    constructor(private modalCtrl: ModalController) {

    }

    public cancel() {

        // TODO 17/07/2024 Roy Schrauwen: Any changes should not be displayed on the taskdetailspage

        return this.modalCtrl.dismiss(null, 'cancel');
    }

    public async confirm() {

        try {
            const response = await this.taskService.saveTask(this.task);
            return this.modalCtrl.dismiss(this.task, 'confirm');
        } catch (error) {
            console.error('[TaskFormComponent] confirm() - Error saving the task:', error);
            this.toastController.create({
                message: 'Wijzigingen niet opgeslagen: <br>' + error.message,
                duration: 2000,
                color: 'danger'
            }).then(toast => toast.present());
        }

    }

    public async addTask() {
        if (this.task.title.trim() !== '') {
            await this.confirm();
            this.task = new Task();
        } else {
            console.warn('[TaskFormComponent] addTask() - title is empty');
        }
    }

    public ionViewWillEnter(): void {
        if (this.task == null) {
            this.task = new Task();
        }
    }

    protected getTitle(): string  {
        return this.task?.title || this.translate.instant('task.addTitle');
    }
}
